export default "__VITE_ASSET__e1a46a9e__"